module.exports = __webpack_public_path__ + "static/media/hostelmgmt.b31a5222.svg";